<template>
  <div style="width: 100%;">
    <v-container fluid>
      <v-row>
        <v-col class='d-flex flex-row align-center'>
          <v-btn text class="mx-2" @click="()=>{$router.go(-1)}">
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          <v-progress-circular
              indeterminate
              color="green"
              v-if="loader"
              style="margin-left: 10px;"
          ></v-progress-circular>
          <span v-if="!loader" class="d-flex flex-column">
            <h1>
              <v-chip :color="utils.getAppointmentStatusColor(data.status)">{{utils.parseAppointmentStatus(data.status)}}</v-chip>
              {{singular}} #{{ data.id }}
            </h1>
            <span>Created By: {{ lookupUsername(data.createdBy) }}</span>
            <span>Created At: {{ utils.formatDate(data.createdAt, 'withTime') }}</span>
            <span v-if="data.sealedBy">Sealed By: {{ lookupUsername(data.sealedBy) }}</span>
            <span v-if="data.sealedAt">Sealed At: {{ utils.formatDate(data.sealedAt, 'withTime') }}</span>
          </span>
          <span class="d-flex flex-row">
            <v-card class="ml-2" max-width="500" v-if="data.outcome && outcomes.length>0" outlined>
              <v-card-title class="pb-0">Outcome</v-card-title>
              <v-card-text class="pt-0 d-flex flex-column">
                <b>{{outcomes.find(x => x.id===data.outcome).name}}</b>
                <p v-if="data.outcome && outcomes.length>0 && data.metadata.sealReason">{{data.metadata.sealReason}}</p>
              </v-card-text>
            </v-card>
            <v-card class="ml-2" max-width="500" v-if="data.status===-1" outlined>
              <v-card-title class="pb-0">User Voided</v-card-title>
              <v-card-text class="pt-0 d-flex flex-column">
                <b>{{lookupUsername(data.userCancelledBy)}}</b>
                <span>{{utils.formatDate(data.userCancelledAt, "withTime")}}</span>
                <p>{{data.userCancelledReason}}</p>
              </v-card-text>
            </v-card>
            <v-card class="ml-2" max-width="500" v-if="data.status===-2" outlined>
              <v-card-title class="pb-0">Customer Voided</v-card-title>
              <v-card-text class="pt-0 d-flex flex-column">
                <b v-if="data.Customer">{{data.Customer.firstName}} {{data.Customer.lastName}}</b>
                <span>{{utils.formatDate(data.customerCancelledAt, "withTime")}}</span>
                <p>{{data.customerCancelledReason}}</p>
              </v-card-text>
            </v-card>
          </span>
          <v-progress-circular
              indeterminate
              color="green"
              v-if="loader2"
              style="margin-left: 10px;"
          ></v-progress-circular>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex flex-row">
          <v-btn class="mr-2" v-if="isAllowed('appointment','u') && (data.status>=0 && data.status<=1)" @click="isEditable = !isEditable"><span v-if="isEditable">Cancel</span><span v-else>Edit</span></v-btn>
          <span class="d-flex flex-row">
            <v-btn v-if="isEditable" class="mr-2" color="success" @click="update">Save</v-btn>
            <v-btn v-if="data.status>=0 && isAllowed('appointment','d')" class="mr-2 error" @click="openVoidAppointmentDialog">Void</v-btn>
          </span>
<!--          <v-btn v-if="data.status===0" class="ml-2" color="info" @click="openRescheduleAppointmentDialog">Reschedule</v-btn>-->
          <v-btn v-if="data.status===0" :loading="startAppointmentLoading" class="mr-2" color="success" @click="startAppointment">Start Appointment</v-btn>
          <v-btn v-if="data.status===1" class="mr-2" color="success" @click="openFinishAppointmentDialog">Finish Appointment</v-btn>
          <v-btn v-if="data.status===2" class="mr-2" color="success" @click="openSealAppointmentDialog">Seal Appointment</v-btn>
          <v-btn v-if="!data.agreedToTerms" class="mr-2" color="warning" @click="openSignAgreementDialog">Sign Agreement</v-btn>
          <v-btn v-else class="mr-2" color="warning" @click="openViewAgreementDialog">View Signed Agreement</v-btn>
        </v-col>
      </v-row>
      <v-form>
        <v-row>
          <v-col cols="8">
            <span v-if="isEditable">
<!--              <v-text-field disabled label="Scheduled For" v-model="customizedData.scheduledFor" type="date" outlined dense/>-->
              <v-text-field label="Wedding Date" v-model="customizedData.weddingDate" type="date" outlined dense/>
              <v-text-field label="Max Budget" v-model="data.budget" type="number" outlined dense/>
              <v-text-field label="Number of Accompaniments" v-model="data.occupants" type="number" outlined dense/>
              <v-select
                  :items="genders"
                  item-text="name"
                  item-value="id"
                  label="Gender"
                  outlined
                  dense
                  v-model="data.gender"
              />
              <span class="d-flex flex-row align-center">
                <b class="mr-2">Intentions</b>
                <span class="mr-3" v-for="(intention, i) in activityTypes" :key="i">
                  <v-checkbox v-model="data.intentions" :label="intention.name" :value="intention.id"/>
                </span>
              </span>
              <v-select :items="appointmentTypes" item-text="name" item-value="id" outlined dense class="mr-3" v-model="data.appointmentType" label="Walk-In"/>
              <!-- <v-checkbox label="Agreed to TOS" v-model="data.agreedToTerms"/> -->
              <span class="d-flex flex-row">
                <v-checkbox label="Confirmation Call Attempted" v-model="data.metadata.confirmationCallAttempted"/>
                <v-checkbox class="ml-4" label="Confirmation Call Successful" v-model="data.metadata.confirmationCallSuccess"/>
              </span>
              <span>
                <h2>Additional Information</h2>
<!--                <v-text-field
                    label="Identifiable Name"
                    outlined
                    v-model="data.name"
                    dense
                />-->
                <v-textarea label="Notes" outlined dense v-model="data.notes"/>
              </span>
              <v-radio-group v-model="data.branchId" row>
                <v-radio v-for="(loc, i) in getLocations" :key="i" :label="loc.name" :value="loc.id"/>
              </v-radio-group>
              <span class="d-flex flex-row">
                <v-checkbox class="mr-3" v-model="data.isWalkIn" disabled label="Walk-In"/>
                <v-checkbox class="mr-3" v-model="data.metadata.force" disabled label="Force Create"/>
                <v-checkbox class="mr-3" v-model="data.metadata.firstAppointment" disabled label="First Appointment"/>
              </span>
            </span>
            <v-card class="pa-5" v-else outlined>
              <h1>
                <span v-if="data.Customer">{{data.Customer.firstName}} {{data.Customer.lastName}}</span>
                <span class="ml-3" v-if="data.gender"></span>
                <v-chip class="ml-3" v-if="data.branchId">{{lookupLocationIcon(data.branchId)}} {{lookupLocationIcon(data.branchId)!==lookupLocation(data.branchId)?lookupLocation(data.branchId):''}}</v-chip>
                <v-chip class="ml-3 purple white--text" square v-if="data.appointmentType">{{ this.appointmentTypes.find(x=>x.id==data.appointmentType)?this.appointmentTypes.find(x=>x.id==data.appointmentType).name:"" }}</v-chip>
                <v-chip class="ml-3 error " v-if="data.metadata && data.metadata.firstAppointment && data.metadata.firstAppointment==true">First Appointment</v-chip>
                <v-chip class="ml-3 warning " v-else>Returning Appointment</v-chip>
                <v-chip class="ml-3 orange white--text" v-if="data.metadata && data.metadata.confirmationCallAttempted && data.metadata.confirmationCallAttempted==true">Conf. Call Attempted</v-chip>
                <v-chip class="ml-3 teal white--text" v-if="data.metadata && data.metadata.confirmationCallSuccess && data.metadata.confirmationCallSuccess==true">Conf. Call Successful</v-chip>
                <span class="ml-3" v-if="data.agreedToTerms==true"><v-icon class="success--text" xLarge>mdi-check-decagram</v-icon></span>
              </h1>
              <div class="d-flex flex-row mt-3" style="width: 100%;">
                <v-card class="pa-3 mr-4" outlined style="width: 50%;">
                  <v-card-text>
                    <h2 class="d-flex flex-row align-center "><v-icon large class="warning--text mr-2">mdi-clipboard-text-clock</v-icon>{{utils.customFormatDate(data.scheduledFor)}}<span v-if="data.metadata && data.metadata.force"><v-chip small class="ml-3 warning">Force Created</v-chip></span></h2>
                  </v-card-text>
                </v-card>
                <v-card class="pa-3 mr-4" outlined style="width: 50%;">
                  <v-card-text>
                    <h2 class="d-flex flex-row align-center "><v-icon large class="purple--text mr-2">mdi-church</v-icon>{{utils.customFormatDate(data.weddingDate, "notime")}}</h2>
                  </v-card-text>
                </v-card>
              </div>
              <div class="d-flex flex-row mt-3" style="width: 100%;">
                <v-card class="pa-3 mr-4" outlined style="width: 33%;">
                  <v-card-text>
                    <h2 class="d-flex flex-row align-center "><v-icon large class="info--text mr-2">mdi-account-group</v-icon>{{data.occupants}} Person<span v-if="data.occupants>1">s</span></h2>
                  </v-card-text>
                </v-card>
                <v-card class="pa-3 mr-4" outlined style="width: 33%;">
                  <v-card-text>
                    <h2 class="ml-4 d-flex flex-row align-center "><v-icon large class="success--text mr-2">mdi-cash-multiple</v-icon>{{utils.formatCurrency(data.budget)}}</h2>
                  </v-card-text>
                </v-card>
                <v-card class="pa-3 mr-4" outlined style="width: 33%;">
                  <v-card-text>
                    <h2 class="d-flex flex-row align-center "><v-icon large class="grey--text mr-2">mdi-gender-male-female</v-icon>{{ genders.find(x => x.id===(data.gender||0)).name }}</h2>
                  </v-card-text>
                </v-card>
              </div>
              <div class="d-flex flex-row mt-3">
                <v-card class="pa-3 mr-4" style="width: 50%;" outlined>
                  <v-card-title>Intentions</v-card-title>
                  <v-card-text>
                    <v-chip class="mr-2 mb-2 info" v-for="(intention,index) in data.intentions" :key="index">
                      <h3>{{activityTypes.find(x=>x.id==intention)?activityTypes.find(x=>x.id==intention).name:""}}</h3>
                    </v-chip>
                  </v-card-text>
                </v-card>
                <v-card class="pa-3 mr-4" style="width: 50%;" outlined>
                  <v-card-title>Notes</v-card-title>
                  <v-card-text>
                    <v-textarea
                        v-model="data.notes"
                        outlined
                        @change="updateNotes"
                    />
                    <v-btn block color="success">Save Note</v-btn>
                  </v-card-text>
                </v-card>
              </div>
            </v-card>
            <h2 class="mt-5 mb-2 align-center">
              <span class="">Associated Jobs</span>
              <v-btn @click="openLinkJobToAppointmentDialog" class="ml-2" fab x-small color="info"><v-icon>mdi-plus</v-icon></v-btn>
            </h2>
            <span v-if="data.Jobs.length>0">
              <v-card v-for="(job, i) of data.Jobs" :key="i" @click="$router.push(`/jobs?selected=${job.id}`)" class="mb-2" outlined elevation="0">
                <v-card-text class="d-flex flex-row justify-space-around flex-grow-1">
                  <v-col class="pa-0 d-flex flex-column">
                    <h3>Job #{{job.id}}</h3>
                  </v-col>
                  <v-col class="pa-0 d-flex flex-column">
                    <span>Type: {{jobTypes.find(x => x.id===(job.type||0)).name}}</span>
                    <span>Gender: {{genders.find(x => x.id===(job.gender||0)).name}}</span>
                  </v-col>
                  <v-col class="pa-0 d-flex flex-column">
                    <span v-if="job.Item && job.Item.Asset">Item: {{job.Item.Asset.styleNo}} {{job.Item.colour?`(${job.Item.colour})`:'(No Colour)'}}</span>
                    <span>Status: {{utils.parseJobStatus(job.status)}}</span>
                  </v-col>
                </v-card-text>
              </v-card>
            </span>
            <span v-else>None</span>
          </v-col>
          <v-col cols="4">
            <span v-if="data.Customer">
              <span class="d-flex flex-row align-center">
                <h2>Customer Information</h2>
                <v-btn class="ml-2" x-small color="info" fab @click="$router.push({path: '/customers', query: {selected: data.Customer.id}})"><v-icon>mdi-arrow-right</v-icon></v-btn>
              </span>
              <span class="mb-3 d-flex flex-column">
                <span><b>Name:</b> {{data.Customer.firstName}} {{data.Customer.lastName}}</span>
                <span class="d-flex flex-row">
                  <span><b>Phone:</b> {{data.Customer.phone}}</span>
                  <span v-if="data.Customer.email" class="ml-3"><b>Email:</b> {{data.Customer.email}}</span>
                </span>
                <span v-if="data.Customer.address.line1"><b>Address Line 1:</b> {{data.Customer.address.line1}}</span>
                <span v-if="data.Customer.address.line2"><b>Address Line 2:</b> {{data.Customer.address.line2}}</span>
                <span v-if="data.Customer.address.city"><b>Address City:</b> {{data.Customer.address.city}}</span>
              </span>
            </span>
            <h2>{{secondaryPlural}}</h2>
            <span>
              <span v-if="data.status===1" class="d-flex flex-row mb-5">
                <v-btn @click="openActivityDialog(activityType)" class="mx-1" :color="colors[activityTypes.findIndex(x => x.id===activityType.id)]" v-for="(activityType, i) of activityTypesBeforeFinish" :key="i">+ {{getActivityType(activityType.id)}}</v-btn>
              </span>
              <span v-if="data.status===2" class="d-flex flex-row mb-5">
                <v-btn @click="openActivityDialog(activityType)" class="mx-1" :color="colors[activityTypes.findIndex(x => x.id===activityType.id)]" v-for="(activityType, i) of activityTypesAfterFinish" :key="i">+ {{getActivityType(activityType.id)}}</v-btn>
              </span>
              <span v-if="data.status===0">
                <h3>You must start this appointment before adding {{secondaryPluralLower}} to it.</h3>
              </span>
              <span v-if="data.status!==0">
                <span v-if="data.AppointmentAssetJoins && data.AppointmentAssetJoins.length>0">
                  <div style="height: 600px; overflow-y: auto">
                    <v-card class="mb-1" v-for="(activity, i) of data.AppointmentAssetJoins" :key="i" :color="colors[activityTypes.findIndex(x => x.id===activity.activityType)] || colors[4]">
                      <v-card-text class="d-flex flex-column">
                        <span class="d-flex flex-row justify-space-between">
                          <h3><b>{{getActivityType(activity.activityType)}}  #</b>{{getAssetName(activity.assetId)}}</h3>
                          <span>{{utils.formatDate(activity.createdAt, 'withTime')}}</span>
                        </span>
                        <span v-if="activity.metadata && activity.metadata.notes"><b>Notes: </b>{{activity.metadata.notes}}</span>
                      </v-card-text>
                    </v-card>
                  </div>
                </span>
                <span v-else>No {{secondaryPluralLower}} on this appointment.</span>
              </span>
            </span>
          </v-col>
        </v-row>
      </v-form>
    </v-container>

    <v-dialog fullscreen hide-overlay v-model="signAgreementDialog.isOpen" max-width="1200">
      <v-card>
        <v-card-title>
          <h2>Terms of Service</h2>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <div style="color: white;" v-html="getGlobalValue('APPOINTMENT_TERMS_OF_SERVICE')"></div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div>
                <b>
                  <i>I, <span v-if="data.Customer">{{data.Customer.firstName}} {{data.Customer.lastName}}</span><span v-else>[CUSTOMER NAME LOADING]</span>, agree to the aforementioned terms and conditions, on {{ utils.customFormatDate(new Date(), 'notime') }}.</i></b>
                <VueSignaturePad v-if="signAgreementDialog.isOpen" width="1000px" height="200px" style="border: 2px solid grey; border-radius: 10px;" ref="signaturePad" :options="{onBegin: () => {$refs.signaturePad.resizeCanvas()}, onEnd: checkSigPadValid}" />
                <v-btn @click="clearSig" color="warning" class="mt-3">Clear Signature Pad</v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex flex-row justify-end">
          <v-btn color="error" @click="closeSignAgreementDialog">
            Cancel
          </v-btn>
          <v-btn color="success" :disabled="!signAgreementDialog.isValid" @click="addSignatureToAppointment" :loading="signAgreementDialog.isLoading">Sign</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog fullscreen hide-overlay v-model="viewAgreementDialog.isOpen" max-width="1200">
      <v-card>
        <v-card-title>
          <div style="width: 100%;" class="d-flex flex-row justify-space-between">
            <div class="d-flex flex-row">
              <h2>Terms of Service</h2>
              <v-btn class="ml-2" fab x-small icon @click="printAppointmentAgreement"><v-icon>mdi-printer</v-icon></v-btn>
            </div>
            <v-btn icon @click="closeViewAgreementDialog"><v-icon>mdi-close</v-icon></v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <div style="color: white;" v-html="getGlobalValue('APPOINTMENT_TERMS_OF_SERVICE')"></div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div class="d-flex flex-column">
                <b><i>I, <span v-if="data.Customer">{{data.Customer.firstName}} {{data.Customer.lastName}}</span><span v-else>[CUSTOMER NAME LOADING]</span>, agree to these terms and conditions, on {{ utils.customFormatDate(new Date(), 'notime') }}.</i></b>
                <img v-if="data.metadata && data.metadata.media && data.metadata.media.length > 0" :src="data.metadata.media[0].url" style="width: 600px; border: 2px solid grey; border-radius: 10px;" alt="">
                <div>Signed At: {{ utils.customFormatDate(data.metadata.signedAt, 'notime') }}</div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="activityCreateDialog.isOpen" max-width="1200">
      <v-card>
        <v-card-title>Create New {{getActivityType(activityCreateDialog.data.activityType)}} {{secondarySingular}}</v-card-title>
        <v-card-text class="">
          <v-row>
            <v-col cols="4">
              <v-card outlined>
                <v-card-text>
                  <span class="d-flex flex-row">
                    <v-autocomplete
                        v-model="activityCreateDialog.selectedId"
                        label="Asset"
                        :items="assets"
                        item-text="styleNo"
                        item-value="id"
                        outlined
                        @change="updateActivityDialog"
                    />
                    <v-btn class="ml-1 mt-2" @click="showCreateAssetDialog" color="info" small fab><v-icon>mdi-plus</v-icon></v-btn>
                  </span>
                  <!-- <v-textarea
                    v-model="activityCreateDialog.data.metadata.notes"
                    label="Notes"
                    outlined
                    @change="updateActivityDialog"
                  /> -->
                  <v-btn block color="info" :disabled="activityCreateDialog.selectedId==''" @click="addToActivityAssetIds">Add Asset</v-btn>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="8">
              <v-card outlined>
                <v-card-title>Assets to add</v-card-title>
                <v-card-text>
                  <span class="d-flex flex-column" v-if="activityCreateDialog.data.assetIds && activityCreateDialog.data.assetIds.length > 0">
                    <v-card outlined class="mb-1" v-for="(item,index) in activityCreateDialog.data.assetIds" :key="index">
                      <v-card-text class="pb-0">
                        <span class="d-flex flex-row justify-space-between">
                          <v-chip color="info">{{getAssetName(item.id)}}</v-chip>
                          <v-textarea height="60" class="mx-2" label="Notes" outlined dense v-model="item.notes"/>
                          <v-btn @click="removeCreateActivityAsset(index)" fab x-small color="error"><v-icon>mdi-close</v-icon></v-btn>
                        </span>
                      </v-card-text>
                    </v-card>
<!--                    <v-chip v-for="(item,index) in activityCreateDialog.data.assetIds" :key="index" color="info" class="mr-2 mb-2" close @click:close="removeCreateActivityAsset(index)">{{getAssetName(item.id)}}</v-chip>-->
                  </span>
                  <span v-else>No Items added.</span>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeActivityDialog">
            Cancel
          </v-btn>
          <v-btn color="success" :disabled="!activityCreateDialog.isValid" @click="createActivity" :loading="activityCreateDialog.isLoading">Create All</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="voidAppointmentDialog.isOpen" max-width="600">
      <v-card>
        <v-card-title>Void {{singular}}</v-card-title>
        <v-card-text class="">
          <v-textarea
              v-model="voidAppointmentDialog.data.reason"
              label="Reason"
              outlined
          />
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeVoidAppointmentDialog">
            Cancel
          </v-btn>
          <v-btn color="success" :disabled="voidAppointmentDialog.data.reason.length===0" @click="voidAppointment" :loading="voidAppointmentDialog.isLoading">Void</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="finishAppointmentDialog.isOpen" max-width="700">
      <v-card class="d-flex flex-column align-center">
        <v-card-title>Finish {{singular}}</v-card-title>
        <v-card-text class="text-center">
          <h3>Finishing an appointment means you won't be able to modify any more activities.</h3>
          <h3>You will be able add purchase engagements after finishing.</h3>
          <h3>Are you sure you want to do this?</h3>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeFinishAppointmentDialog">
            Cancel
          </v-btn>
          <v-btn color="success" @click="finishAppointment" :loading="finishAppointmentDialog.isLoading">Finish</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="sealAppointmentDialog.isOpen" max-width="700">
      <v-card class="d-flex flex-column align-center">
        <v-card-title>Seal {{singular}}</v-card-title>
        <v-card-text class="text-center">
          <v-select
              :items="outcomes"
              item-text="name"
              item-value="id"
              label="Appointment Outcome"
              outlined
              v-model="sealAppointmentDialog.outcome"
          />
          <v-textarea v-if="requiresReason" label="Reason" v-model="sealAppointmentDialog.reason" outlined/>
          <h3>Sealing an appointment means you won't be able to make any changes afterwards.</h3>
          <h3>Are you sure you want to do this?</h3>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeSealAppointmentDialog">
            Cancel
          </v-btn>
          <v-btn :disabled="!sealAppointmentDialog.outcome || (requiresReason && !sealAppointmentDialog.reason)" color="success" @click="sealAppointment" :loading="sealAppointmentDialog.isLoading">Seal</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="rescheduleAppointmentDialog.isOpen" max-width="700">
      <v-card class="d-flex flex-column align-center">
        <v-card-title>Reschedule {{singular}}</v-card-title>
        <v-card-text class="text-center">
          //reschedule picker goes here
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeRescheduleAppointmentDialog">
            Cancel
          </v-btn>
          <v-btn :disabled="!rescheduleAppointmentDialog.outcome" color="success" @click="rescheduleAppointment" :loading="rescheduleAppointmentDialog.isLoading">Reschedule</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="createAssetDialog.isOpen" max-width="600">
      <v-card>
        <v-card-title>
          Create New Asset (Default Item)
        </v-card-title>
        <v-card-text class="pa-5">
          <v-form v-model="validCreateAsset">
            <v-text-field
                label="Style No."
                outlined
                :rules="rules.required"
                v-model="createAssetDialog.data.styleNo"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeCreateAsset">
            Cancel
          </v-btn>
          <v-btn color="success" :disabled="!validCreateAsset" @click="createAsset" :loading="createAssetDialog.loading">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="linkJobToAppointmentDialog.isOpen" max-width="600">
      <v-card>
        <v-card-title>Job Appointment Linking</v-card-title>
        <v-card-text class="d-flex flex-row justify-space-between align-center fill-height">
          <v-card outlined class="d-flex flex-column mr-1 flex-grow-1">
            <v-card-subtitle>Create New Job?</v-card-subtitle>
            <v-card-text>
              <v-btn color="info" @click="createJobFromAppointment">Create Job <v-icon>mdi-arrow-right</v-icon></v-btn>
            </v-card-text>
          </v-card>
          <span>OR</span>
          <v-card outlined class="d-flex flex-column ml-1 flex-grow-1">
            <v-card-subtitle>Link to Existing Job?</v-card-subtitle>
            <v-card-text>
              <v-text-field outlined dense label="Job #" v-model="linkJobToAppointmentDialog.id" type="number"/>
              <v-btn color="success" :disabled="!linkJobToAppointmentDialog.id || isNaN(linkJobToAppointmentDialog.id)" @click="linkJobToAppointment" :loading="linkJobToAppointmentDialog.loading">Link</v-btn>
            </v-card-text>
            <v-card-text v-if="linkJobToAppointmentDialog.showBypass" class="d-flex flex-column">
              <span class="red--text">This job is already linked to another appointment. Do you want to override?</span>
              <v-btn color="error" @click="linkJobToAppointmentBypass">Override</v-btn>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeLinkJobToAppointmentDialog">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialog-snack ref="snackbar" :color="snackObj.color" :text="snackObj.text"/>
  </div>
</template>

<script>
import axios from 'axios';
import {mapGetters} from "vuex";
import utils from '../../plugins/helpers'

export default {

  data () {
    return {
      utils: utils,
      viewAgreementDialog: {
        isOpen: false,
      },
      signAgreementDialog: {
        isLoading: false,
        isOpen: false,
        isValid: false,
        data: {}
      },
      loader2: false,
      deleteDialog: false,
      deleteConfirmed: true,
      loader: true,

      rules: {
        required: [v => !!v || 'This field is required.'],
      },

      snackObj: {
        color: '',
        text: ''
      },

      max25chars: v => v.length <= 25 || 'Input too long!',
      editMode: false,
      data: {
        Jobs: [],
        metadata: {}
      },
      customizedData: {},

      singular: "Appointment",
      singularLower: "appointment",
      plural: "Appointments",
      pluralLower: "appointments",

      secondaryPluralLower: "engagements",
      secondaryPlural: "Engagements",
      secondarySingularLower: "engagement",
      secondarySingular: "Engagement",

      isEditable: false,

      activityTypes: [],
      activityTypesBeforeFinish: [],
      activityTypesAfterFinish: [],
      assets: [],
      appointmentTypes: [],
      outcomes: [],

      colors: ['cyan', '#F08080', 'orange', 'lime', 'amber'],
      jobTypes: [
        {name: "None",id: 0},
        {name: "Formal 👗",id: 1},
        {name: "Bridal 💍",id: 2}
      ],
      genders: [
        {name: "None",id: 0},
        {name: "Groom 🤵",id: 1},
        {name: "Bride 👰",id: 2}
      ],

      activityCreateDialog: {
        isOpen: false,
        isLoading: false,
        isValid: false,
        selectedId: '',
        assetsToDisplay: [],
        data: {
          assetIds: [],
          metadata: {}
        }
      },

      voidAppointmentDialog: {
        isOpen: false,
        isLoading: false,
        data: {
          reason: ""
        }
      },

      startAppointmentLoading: false,
      finishAppointmentDialog: {
        isOpen: false,
        isLoading: false,
      },
      sealAppointmentDialog: {
        isOpen: false,
        isLoading: false,
        outcome: null,
        reason: ""
      },
      rescheduleAppointmentDialog: {
        isOpen: false,
        isLoading: false,
        data: {},
      },

      createAssetDialog: {
        isOpen: false,
        loading: false,
        data: {}
      },
      validCreateAsset: false,

      linkJobToAppointmentDialog: {
        isOpen: false,
        loading: false,
        showBypass: false,
        id: null
      }
    }
  },
  async mounted(){
    try {
      this.loader = true;
      let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}/${this.$route.params.id}`)
      if(res.data.error) throw res.data.error

      this.data = res.data.data

      this.customizedData.scheduledFor = utils.parseDate(this.data.scheduledFor)
      this.customizedData.weddingDate = utils.parseDate(this.data.weddingDate)

      res = await axios.get(`${this.getEndpoint}/api/activityTypes`)
      if(res.data.error) throw res.data.error
      this.activityTypes = res.data.data;
      this.activityTypesBeforeFinish = this.activityTypes.filter(x => [1, 2].includes(x.id));
      this.activityTypesAfterFinish = this.activityTypes.filter(x => [4].includes(x.id));

      res = await axios.get(`${this.getEndpoint}/api/appointmentTypes`)
      if(res.data.error) throw res.data.error
      this.appointmentTypes = res.data.data

      res = await axios.get(`${this.getEndpoint}/api/assets`)
      if(res.data.error) throw res.data.error
      this.assets = res.data.data

      res = await axios.get(`${this.getEndpoint}/api/appointmentOutcomes`)
      if(res.data.error) throw res.data.error
      this.outcomes = res.data.data

    } catch (error) {
      console.error(error)
      this.snack(error.msg || error, "error");
    } finally {
      this.loader = false;
    }
  },
  watch: {
    activityCreateDialog: {
      handler: function(x){
        console.log("watcher", x)
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(['getEndpoint', "isAllowed", 'lookupUsername', 'getGlobalValue', 'getLocations', 'lookupLocation', 'lookupLocationIcon']),
    requiresReason(){
      let foundOutcome = this.outcomes.find(x => x.id===this.sealAppointmentDialog.outcome);
      if(foundOutcome){
        if(foundOutcome.metadata){
          return foundOutcome.metadata.requestReason || false;
        }
      }
      return false;
    }
  },
  methods: {
    printAppointmentAgreement(){
      window.print()
    },
    // async addPhotoToJob(){
    //   try {
    //     this.photoDialog.addPhotoLoader = true
    //     let data = new FormData()
    //     let img = this.$refs.canvas.toDataURL('image/jpeg', 1.0)
    //     data.append('file', img)
    //     let res = await axios.post(`${this.getEndpoint}/api/jobs/photo/${this.$route.query.selected}`, data, {
    //       header : {
    //         'Content-Type' : 'multipart/form-data'
    //       }
    //     })
    //     if(res.data.error) throw res.data.error
    //     this.photoDialog.isPhotoTaken = false
    //     if(!this.selectedRow.metadata.media) this.selectedRow.metadata.media = []
    //     this.selectedRow.metadata.media = res.data.data.reverse()
    //   } catch (error) {
    //     console.log(error)
    //     this.snack(error.msg||error)
    //   } finally {
    //     this.photoDialog.addPhotoLoader = false
    //   }
    // },
    checkSigPadValid(){
      console.log('fired')
      if(this.$refs.signaturePad.isEmpty()){
        this.signAgreementDialog.isValid = false
      }else{
        this.signAgreementDialog.isValid = true
      }
    },
    clearSig() {
      this.$refs.signaturePad.clearSignature();
      this.checkSigPadValid()      
    },
    async addSignatureToAppointment(){
      try {
        this.signAgreementDialog.isLoading = true

        const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
        if(isEmpty){
          this.snack("No signature provided.")
          this.signAgreementDialog.isLoading = false
          return
        }

        let formData = new FormData()
        let img = data
        formData.append('file', img)
        let res = await axios.post(`${this.getEndpoint}/api/${this.pluralLower}/${this.data.id}/addSignature`, formData, {
          header : {
            'Content-Type' : 'multipart/form-data'
          }
        })
        if(res.data.error) throw res.data.error
        
        this.snack(`${this.singular} Updated 🎉`, "success")
        this.data.agreedToTerms = true
        if(!this.data.metadata){
          this.data.metadata = {signedAt: '', media: []}
        }
        this.data.metadata.signedAt = res.data.data.signedAt
        this.data.metadata.media = res.data.data.media
        this.isEditable = false;
        this.closeSignAgreementDialog()

      } catch (error) {
        console.error(error)
        this.snack(error.msg || error, "error");
      } finally {
        this.signAgreementDialog.isLoading = false;
      }
    },
    async openViewAgreementDialog(){
      this.viewAgreementDialog.isOpen = true
    },
    closeViewAgreementDialog(){
      this.viewAgreementDialog.isOpen = false
    },
    async openSignAgreementDialog(){
      this.signAgreementDialog.isOpen = true
      this.signAgreementDialog.isValid = false
      this.signAgreementDialog.data = {}
    },
    closeSignAgreementDialog(){
      this.signAgreementDialog.isOpen = false
      this.signAgreementDialog.isValid = false
      this.signAgreementDialog.data = {}
    },
    addToActivityAssetIds(){
      if(!this.activityCreateDialog.selectedId) return
      this.activityCreateDialog.data.assetIds.push({id: this.activityCreateDialog.selectedId, notes: ""})
      this.activityCreateDialog.selectedId = ""
    },
    removeCreateActivityAsset(i){
      this.activityCreateDialog.data.assetIds.splice(i, 1);
    },
    getAssetName(asset){
      let found = this.assets.find(x => x.id===asset);
      return found?found.styleNo:'Unknown';
    },
    getActivityType(activity){
      switch(activity){
        case 2:
          return "Tried"
        case 1:
          return "Viewed"
        case 4:
          return "Purchased"
        default:
          return "Unknown"
      }
    },
    updatePage(newData){
      this.data = {...this.data, ...newData};

      this.customizedData.scheduledFor = utils.parseDate(this.data.scheduledFor)
      this.customizedData.weddingDate = utils.parseDate(this.data.weddingDate)
    },
    async update(){
      try {
        this.loader = true;

        this.data.weddingDate = this.customizedData.weddingDate;

        let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/${this.data.id}`, this.data)
        if(res.data.error) throw res.data.error
        console.log(res.data.data)
        this.snack(`${this.singular} Updated 🎉`, "success")

        this.updatePage(res.data.data)

        this.isEditable = false;
      } catch (error) {
        console.error(error)
        this.snack(error.msg || error, "error");
      } finally {
        this.loader = false;
      }
    },
    async updateNotes(){
      try {
        this.loader2 = true;

        if(!this.data?.notes) this.data.notes = ""
        let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/${this.data.id}/notes`, {notes: this.data.notes})
        if(res.data.error) throw res.data.error

        this.snack(`${this.singular} Updated note 🎉`, "success")

      } catch (error) {
        console.error(error)
        this.snack(error.msg || error, "error");
      } finally {
        this.loader2 = false;
      }
    },
    async voidAppointment(){
      try {
        this.voidAppointmentDialog.isLoading = true
        let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/${this.data.id}/userVoid`, this.voidAppointmentDialog.data)
        if(res.data.error) throw res.data.error

        this.snack(this.singular+" Cancelled 🎉", "success");

        this.updatePage(res.data.data)

        this.closeVoidAppointmentDialog();
      } catch (error) {
        console.error(error)
        this.snack(error.msg || error, "error");
      } finally {
        this.voidAppointmentDialog.isLoading = false;
      }
    },
    openVoidAppointmentDialog(){
      this.voidAppointmentDialog.isOpen = true;
      this.voidAppointmentDialog.data = {
        reason: ""
      }
    },
    closeVoidAppointmentDialog(){
      this.voidAppointmentDialog = {
        isOpen: false,
        isLoading: false,
        data: {
          reason: ""
        }
      }
    },
    snack(text, color=""){
      this.snackObj.text = text;
      this.snackObj.color = color;

      this.$refs.snackbar.openDialog();
    },
    openActivityDialog(type){
      this.activityCreateDialog.isOpen = true;
      this.activityCreateDialog.data = {
        activityType: type.id,
        assetIds: [],
        metadata: {}
      }
      this.updateActivityDialog();
    },
    closeActivityDialog(){
      this.activityCreateDialog = {
        isOpen: false,
        isLoading: false,
        data: {
          assetIds: [],
          metadata: {}
        }
      }
    },
    async createActivity(){
      try {
        this.activityCreateDialog.isLoading = true;

        let res = await axios.post(`${this.getEndpoint}/api/${this.pluralLower}/${this.data.id}/addActivities`, this.activityCreateDialog.data)
        if(res.data.error) throw res.data.error
        if(res.data.data.length>0)
          res.data.data.forEach(x=>this.data.AppointmentAssetJoins.push(x))
        
        this.closeActivityDialog();
      } catch (error) {
        console.error(error)
        this.snack(error.msg || error, "error");
      } finally {
        this.activityCreateDialog.isLoading = false;
      }
    },
    updateActivityDialog(){
      let temp = true;

      this.activityCreateDialog.isValid = temp;
    },
    async createJobFromAppointment(){
      let tempStr = JSON.stringify({customerId: this.data.customerId, gender: this.data.gender, id: this.data.id});
      await this.$router.push({path: `/jobs`, query: {createFromAppointment: tempStr}});
    },
    async startAppointment(){
      try {
        this.startAppointmentLoading = true;
        let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/${this.data.id}/start`)
        if(res.data.error) throw res.data.error

        this.updatePage(res.data.data)
        this.snack("Appointment started!", "success")
      } catch (error) {
        console.error(error)
        this.snack(error.msg || error, "error");
      } finally {
        this.startAppointmentLoading = false;
      }
    },
    openFinishAppointmentDialog(){
      this.finishAppointmentDialog.isOpen = true;
    },
    closeFinishAppointmentDialog(){
      this.finishAppointmentDialog = {
        isOpen: false,
        isLoading: false
      }
    },
    async finishAppointment(){
      try {
        this.finishAppointmentDialog.isLoading = true;
        let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/${this.data.id}/finish`)
        if(res.data.error) throw res.data.error

        this.updatePage(res.data.data)

        this.closeFinishAppointmentDialog();
        this.isEditable = false;
      } catch (error) {
        console.error(error)
        this.snack(error.msg || error, "error");
      } finally {
        this.finishAppointmentDialog.isLoading = false;
      }
    },
    openSealAppointmentDialog(){
      this.sealAppointmentDialog.isOpen = true;
    },
    closeSealAppointmentDialog(){
      this.sealAppointmentDialog = {
        isOpen: false,
        isLoading: false,
        outcome: null,
        reason: ""
      }
    },
    async sealAppointment(){
      try {
        this.sealAppointmentDialog.isLoading = true;
        if(!this.sealAppointmentDialog.outcome) throw "You must select an appointment outcome."
        let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/${this.data.id}/seal`, {outcome: this.sealAppointmentDialog.outcome, reason: this.sealAppointmentDialog.reason})
        if(res.data.error) throw res.data.error

        this.updatePage(res.data.data)

        this.closeSealAppointmentDialog();
        this.isEditable = false;
      } catch (error) {
        console.error(error)
        this.snack(error.msg || error, "error");
      } finally {
        this.sealAppointmentDialog.isLoading = false;
      }
    },
    openRescheduleAppointmentDialog(){
      this.rescheduleAppointmentDialog.isOpen = true;
    },
    closeRescheduleAppointmentDialog(){
      this.rescheduleAppointmentDialog = {
        isOpen: false,
        isLoading: false,
        data: {}
      }
    },
    async rescheduleAppointment(){
      try {
        this.rescheduleAppointmentDialog.isLoading = true;
        let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/${this.data.id}/seal`, {...this.rescheduleAppointmentDialog.data})
        if(res.data.error) throw res.data.error
    
        this.updatePage(res.data.data)
    
        this.closeRescheduleAppointmentDialog();
        this.isEditable = false;
      } catch (error) {
        console.error(error)
        this.snack(error.msg || error, "error");
      } finally {
        this.rescheduleAppointmentDialog.isLoading = false;
      }
    },
    showCreateAssetDialog(){
      this.createAssetDialog.isOpen = true;
    },
    closeCreateAsset(){
      this.createAssetDialog = {
        isOpen: false,
        data: {},
        loading: false
      }
    },
    async createAsset(){
      try{
        this.createAssetDialog.loading = true;

        let res = await axios.post(`${this.getEndpoint}/api/assets`, this.createAssetDialog.data)
        if(res.data.error) throw res.data.error;
        let newId = res.data.data.data.id;

        this.snack(`Asset Created 🎉`);

        res = await axios.get(`${this.getEndpoint}/api/assets`)
        if(res.data.error) throw res.data.error;
        this.assets = res.data.data;

        this.activityCreateDialog = {
          ...this.activityCreateDialog,
          selectedId: newId
        }

        this.closeCreateAsset();
      }
      catch (error) {
        this.createAssetDialog.loading = false;
        console.error(error);
        this.snack(error.msg || error, "error");
      }
    },
    openLinkJobToAppointmentDialog(){
      this.linkJobToAppointmentDialog.showBypass = false;
      this.linkJobToAppointmentDialog.isOpen = true;
    },
    closeLinkJobToAppointmentDialog(){
      this.linkJobToAppointmentDialog = {
        isOpen: false,
        id: null,
        loading: false,
        showBypass: false
      }
    },
    async linkJobToAppointment(){
      try{
        this.linkJobToAppointmentDialog.loading = true;

        let res = await axios.put(`${this.getEndpoint}/api/appointments/${this.data.id}/linkJob`, {id: this.linkJobToAppointmentDialog.id});
        if(res.data.error){
          if(res.data.error.msg==="This job is already linked to an appointment"){
            this.linkJobToAppointmentDialog.showBypass = true;
            return;
          }
          throw res.data.error
        }

        this.snack(`Job Linked 🎉`);

        res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}/${this.$route.params.id}`)
        if(res.data.error) throw res.data.error;

        this.data = res.data.data

        this.customizedData.scheduledFor = utils.parseDate(this.data.scheduledFor)
        this.customizedData.weddingDate = utils.parseDate(this.data.weddingDate)

        this.closeLinkJobToAppointmentDialog();
      }
      catch (error) {
        this.linkJobToAppointmentDialog.loading = false;
        console.error(error);
        this.snack(error.msg || error, "error");
      }
    },
    async linkJobToAppointmentBypass(){
      try{
        this.linkJobToAppointmentDialog.loading = true;

        let res = await axios.put(`${this.getEndpoint}/api/appointments/${this.data.id}/linkJobBypass`, {id: this.linkJobToAppointmentDialog.id});
        if(res.data.error) throw res.data.error;

        this.snack(`Job Linked 🎉`);

        res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}/${this.$route.params.id}`)
        if(res.data.error) throw res.data.error

        this.data = res.data.data

        this.customizedData.scheduledFor = utils.parseDate(this.data.scheduledFor)
        this.customizedData.weddingDate = utils.parseDate(this.data.weddingDate)

        this.closeLinkJobToAppointmentDialog();
      }
      catch (error) {
        this.linkJobToAppointmentDialog.loading = false;
        console.error(error);
        this.snack(error.msg || error, "error");
      }
    }
  }
}
</script>
